import { InvoiceSettingsParams } from "@jugl-web/rest-api";
import { InvoiceTaxRow } from "@web-src/modules/invoices/types";
import { createContext } from "react";
import {
  Control,
  FieldErrors,
  UseFormRegister,
  UseFormWatch,
} from "react-hook-form";

export const InvoicesSettingsPageContext = createContext<{
  formValues: InvoiceSettingsParams;
  register: UseFormRegister<InvoiceSettingsParams>;
  errors: FieldErrors<InvoiceSettingsParams>;
  watch: UseFormWatch<InvoiceSettingsParams>;
  control: Control<InvoiceSettingsParams>;
  customFields: { name: string; value: string }[];
  setCustomFields: (customFields: { name: string; value: string }[]) => void;
  logo: File | undefined;
  setLogo: (logo: File | undefined) => void;
  taxFields: {
    item: InvoiceTaxRow[];
    invoice: InvoiceTaxRow[];
  };
  addTaxField: (level: "item" | "invoice", field: InvoiceTaxRow) => void;
  editTaxField: (level: "item" | "invoice", field: InvoiceTaxRow) => void;
  removeTaxField: (level: "item" | "invoice", name: string) => void;
  setTaxFieldAsDefault: (
    level: "item" | "invoice",
    id: string,
    isDefault: boolean
  ) => void;
  submitForm: () => void;
  isSaving: boolean;
  configId: string | undefined;
} | null>(null);
